var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$_.isEmpty(_vm.addreszerData))?_c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.addreszerData,"rules":_vm.rules,"menu-props":{
    maxHeight: 150,
    offsetY: true,
    offsetOverflow: true,
    transition: false
  },"item-value":"district_code","item-text":"text","placeholder":"ตำบล/แขวง, อำเภอ/เขต, จังหวัด, รหัสไปรษณีย์","outlined":"","dense":""},on:{"update:search-input":function($event){return _vm.handleAutoComplete($event)},"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('div',{staticClass:"secondary--text text-body",domProps:{"innerHTML":_vm._s(
        _vm.highlightText(
          `${item.district}, ${item.amphoe}, ${item.province}, ${item.zipcode}`
        )
      )}})]}}],null,false,2593329432)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }